import * as types from '../types'

export function getAllMaterialsReduced(payload) {
    return {
        type: types.GET_ALL_MATERIALS_REDUCED,
        payload,
    }
}

export function getAllMaterialsReducedSuccess(payload) {
    return {
        type: types.GET_ALL_MATERIALS_REDUCED_SUCCESS,
        payload
    }
}

/** Só os nomes das marcas (~2,6 KB) — é o que a tela precisa no primeiro paint. */
export function getMaterialBrands() {
    return {
        type: types.GET_MATERIAL_BRANDS,
    }
}

export function getMaterialBrandsSuccess(brands) {
    return {
        type: types.GET_MATERIAL_BRANDS_SUCCESS,
        payload: brands,
    }
}

/** Carrega sob demanda os materiais das marcas informadas. */
export function getMaterialsByBrands(brands) {
    return {
        type: types.GET_MATERIALS_BY_BRANDS,
        payload: brands,
    }
}

export function getMaterialsByBrandsSuccess(brands, materials) {
    return {
        type: types.GET_MATERIALS_BY_BRANDS_SUCCESS,
        payload: { brands, materials },
    }
}

/**
 * Descarta o cache por marca depois de editar ou remover um material. Limpa
 * tudo porque a edição pode trocar a marca do material, movendo-o de balde.
 */
export function invalidateMaterialsCache() {
    return {
        type: types.INVALIDATE_MATERIALS_CACHE,
    }
}
